import React from "react";
import { Col } from "react-bootstrap";
import "../../../assets/css/customer/components/SingleCategory.css";
import AppContext from "../../../contexts/AppContext";
import { useContext } from "react";
import { useNavigate } from 'react-router-dom';

const CategoryCard = ({ category, onCategoryClick }) => {
  const { setSelectedCategory, setSelectedShop } = useContext(AppContext);
  const navigate = useNavigate();

  const handleClick = () => {
    setSelectedShop(null);
    setSelectedCategory(category.name);
    navigate("/categories");
  };

  return (
    <Col xs={12} sm={6} md={6} lg={3} className="category-col">
      <div
        className="category-card"
        onClick={handleClick}
        role="button"
        tabIndex={0}
      >
        <div className="category-circle">
          <img
            src={category.defaultImage}
            alt={category.name}
            className="category-image"
          />
        </div>

        <h3 className="category-name">{category.name}</h3>
      </div>
    </Col>
  );
};

export default CategoryCard;